import React, { useState } from 'react';
import { Delete, ViewIcon } from '../../../assets/svg';
import AssignedSafetyMeetingModal from '../../shared/Modal/AssignedSafetyMeetingModal';
import { DeleteConfirmationModal } from '../../shared';
import { popup } from '../../../utils';
import { deleteSafetyMeetingAssociationService } from '../../../utils/apiServices/safetyServiceAPI';
import { useSelector } from 'react-redux';
import { QUERY_KEYS, ROLES } from '../../../constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const SafetyMeetingAssociationActions = ({ data }) => {
    const queryClient = useQueryClient();
    const { account_id, account_name } = data;
    const [showViewModal, setShowViewModal] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const role = useSelector((s) => s?.user?.role);
    const isAllowed = role !== ROLES.SALES_AGENT;

    const deleteSMAMutation = useMutation({
        mutationFn: async (accountId) => await deleteSafetyMeetingAssociationService({ accountId }),
        onSuccess: ({ message }) => {
            popup('success', message);
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.SAFETY_MEETING_ASSOCIATION],
                exact: false,
            });
            setIsDeleteModalOpen(false);
        },
        onError: (error) => popup('error', error.message),
    });

    const deleteHandler = ({ selectedItemId }) => {
        deleteSMAMutation.mutate(selectedItemId);
    };

    return (
        <>
            <div className='d-flex gap-2'>
                <span title={'View files'} id='action-btn' onClick={() => setShowViewModal(true)}>
                    <ViewIcon />
                </span>
                {isAllowed && (
                    <>
                        <span
                            title={'Delete all files'}
                            id='action-btn'
                            onClick={() => setIsDeleteModalOpen(true)}
                        >
                            <Delete />
                        </span>
                        {isDeleteModalOpen && (
                            <DeleteConfirmationModal
                                isDeleteModal={isDeleteModalOpen}
                                setIsDeleteModal={setIsDeleteModalOpen}
                                selectedItemId={account_id}
                                handleDeleteClick={deleteHandler}
                                deleteButtonName={` all safety meetings assigned to ${account_name}`}
                                isLoading={deleteSMAMutation.isPending}
                            />
                        )}
                    </>
                )}
                {showViewModal && (
                    <AssignedSafetyMeetingModal
                        showModal={showViewModal}
                        setShowModal={setShowViewModal}
                        accountName={account_name}
                        accountId={account_id}
                    />
                )}
            </div>
        </>
    );
};

export default SafetyMeetingAssociationActions;
